function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M63.5,117.2V76.5h5.8v16h11.4v-16h5.8v40.7h-5.8V99.4H69.3v17.8H63.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M92.5,76.5H103c2.7,0,4.7,0.3,6.1,1c1.4,0.7,2.6,1.9,3.8,3.5c1.1,1.6,2,3.8,2.7,6.4s1,5.9,1,9.8 c0,3.5-0.3,6.6-1,9.2c-0.7,2.6-1.6,4.7-2.6,6.2c-1.1,1.5-2.3,2.7-3.8,3.4c-1.5,0.8-3.4,1.2-5.7,1.2H92.5V76.5z M98.2,83.4v26.9 h4.4c1.9,0,3.2-0.2,4.1-0.6c0.8-0.4,1.5-1,2.1-1.8c0.5-0.8,1-2.1,1.3-3.9c0.4-1.8,0.5-4.1,0.5-7c0-3-0.2-5.4-0.5-7.1 c-0.4-1.7-0.9-3.1-1.7-4.1c-0.8-1-1.7-1.7-2.8-2c-0.8-0.2-2.4-0.4-4.7-0.4H98.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M121.5,117.2V76.5h12.2c3.1,0,5.4,0.4,6.7,1.1c1.3,0.7,2.4,2,3.3,3.8c0.9,1.8,1.3,4,1.3,6.5 c0,3.2-0.7,5.7-2,7.7s-3.2,3.2-5.6,3.7c1.2,1,2.3,2.2,3.1,3.4c0.8,1.2,1.9,3.4,3.3,6.6l3.5,7.9h-6.9l-4.2-8.8 c-1.5-3.2-2.5-5.2-3.1-6c-0.5-0.8-1.1-1.4-1.7-1.7c-0.6-0.3-1.6-0.5-2.9-0.5h-1.2v17H121.5z M127.3,93.7h4.3c2.6,0,4.3-0.1,5-0.4 c0.7-0.3,1.3-0.8,1.7-1.6s0.7-1.9,0.7-3.2c0-1.3-0.2-2.3-0.7-3.1c-0.4-0.8-1.1-1.3-1.8-1.6c-0.5-0.2-2.1-0.3-4.7-0.3h-4.5V93.7z"
})), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M52.4,44.5c-0.8-0.3-2.3-0.5-4.8-0.5h-2.8v11.6H48c2.2,0,3.6-0.2,4.4-0.5c0.8-0.4,1.4-1,1.9-1.9 c0.5-0.9,0.7-2,0.7-3.4c0-1.4-0.3-2.5-0.8-3.4C53.8,45.5,53.2,44.9,52.4,44.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M70.2,28.8H4c-0.6,0-1.1,0.5-1.1,1.2v61.7c0,0.7,0.5,1.2,1.1,1.2h49.6c0.6,0,1.1-0.5,1.1-1.2V69.3 c0-2.6,2-4.7,4.4-4.7h11.1c0.6,0,1.1-0.5,1.1-1.2V30C71.4,29.4,70.8,28.8,70.2,28.8z M29.7,75.4c-2,2.1-4.6,3.1-7.5,3.1 c-3.7,0-6.8-1.7-9.1-5c-2.7-3.9-4-9.1-4-15.6c0-6.9,1.3-12.4,4-16.3c2.3-3.4,5.5-5.1,9.5-5.1c3.2,0,5.9,1.3,8.1,3.8 c1.5,1.8,2.7,4.5,3.4,8.1l-5.7,1.9c-0.4-2.2-1.1-3.9-2.2-5.1c-1.1-1.2-2.4-1.8-3.9-1.8c-2.1,0-3.9,1.1-5.2,3.2 c-1.3,2.1-2,5.7-2,10.6c0,5.1,0.7,8.8,2,10.9c1.3,2.2,3,3.2,5.1,3.2c1.5,0,2.9-0.7,4-2.1c1.1-1.4,1.9-3.6,2.4-6.6l5.6,2.5 C33.2,70,31.8,73.3,29.7,75.4z M59.6,57.1c-1,2-2.2,3.4-3.6,4.2c-1.4,0.8-3.9,1.2-7.4,1.2h-3.8v15.3H39V37.2h9.3 c3.5,0,5.7,0.2,6.8,0.6c1.7,0.6,3.1,2,4.2,4c1.1,2.1,1.7,4.7,1.7,7.9C61.1,52.7,60.6,55.1,59.6,57.1z"
}))));

var SvgCustomPictureIcon = function SvgCustomPictureIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCustomPictureIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/custom-picture-icon.06fbfb39.svg";
export { ForwardRef as ReactComponent };